


















































import SwitchByUa from '@/components/atoms/SwitchByUa.vue'
import { ApiContent } from '@/models/api/content'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { allInactive, ApplicationState } from '@/models/application-state/application-state'
import { PluginMixin } from '@spa/mixins/plugin'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    SwitchByUa,
  },
})
export default class PresetLayout extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ default: ApiContent.empty })
  readonly headerFreeArea: ApiContent

  @Prop({ default: allInactive })
  readonly applicationState: ApplicationState

  @Prop({ default: '/' })
  readonly topUrl: string

  behaviorConfig = new BehaviorConfig()

}
